import { useQuery } from "@tanstack/react-query";
import apiClient from "../client";

// A customer's private documents, read by an admin. Every call here is audit-logged
// server-side (VAULT_LIST): an admin reading documents that are not theirs is a
// sensitive reveal and gets the same treatment as a PII reveal.
//
// No staleTime: unlike letter settings, this must not be served from cache on a
// revisit, because each fresh read is what produces the audit entry.
const useUserDocumentsQuery = (userId) =>
  useQuery({
    queryKey: ["vault-documents", userId],
    queryFn: () =>
      apiClient.get(`/vault/admin/users/${userId}/documents`).then((res) => res.data?.data),
    enabled: !!userId,
  });

export default useUserDocumentsQuery;
